function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.725 6.906l.943 1.632A2.153 2.153 0 0110.8 11.77H9.533V13l-3.077-2.154 3.077-2.154v1.231h1.27a.308.308 0 00.29-.411l-.024-.05-.942-1.633 1.598-.923zm-7.277-1.67l.326 3.742-1.065-.616-.635 1.1a.308.308 0 00.211.456l.056.005h1.885v1.846H3.34a2.153 2.153 0 01-1.866-3.23l.635-1.1-1.066-.615 3.404-1.588zm3.7-3.947c.328.189.6.46.788.788l.635 1.099 1.066-.616-.327 3.742-3.403-1.588L7.97 4.1l-.633-1.1a.308.308 0 00-.501-.045L6.805 3l-.942 1.632-1.599-.923.942-1.632a2.154 2.154 0 012.943-.788z",
  fill: "currentColor"
});

var SvgRecycle = function SvgRecycle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgRecycle;